/* eslint-disable no-unused-vars */
// **  cognito helper
import { CognitoAuth } from "@contexts/auth/cognito"
import { groupsFromJwtPayload } from "@configs/adminRoles"

// **  store names
import { STORES } from "@constants/redux"

// ** main app Logger
import { appLogger } from "@helpers/logger"

// ** constants
import { globalConst } from "@constants/global"

// ** system wide config
import systemConfig from "@configs/systemConfig"

// ** Acl subject,actions
import { AclSubjects, AclActions } from "@constants/acl"

// **  utility
import { concat, uniq, sortBy, merge } from "lodash"

/** users groups */
const GROUP = globalConst.auth.groups

const resolveAuthGroups = (idTokenPayload = {}) => {
  const cognitoGroups = idTokenPayload["cognito:groups"]
  let groupData = cognitoGroups
    ? Array.isArray(cognitoGroups)
      ? cognitoGroups
      : [cognitoGroups]
    : [GROUP.NO_GROUP]
  if (groupData.length === 1 && groupData[0] === GROUP.NO_GROUP && idTokenPayload.adminRole) {
    groupData = groupsFromJwtPayload(idTokenPayload)
  }
  return groupData
}

/** initla state for auth store  */
const initialState = {
  user: null,
  username: null,
  attributes: {},
  loggedIn: false,
  messgae: null,
  token: null,
  alerts: [],
  alertsFetched: false,
  ability: {
    action: AclActions.MANAGE,
    subject: AclSubjects.HOME
  },
  redirect: "/",
  action: globalConst.action.NONE,
  state: CognitoAuth.AuthStatus.UNAUTHENTIFICATED,
  challenge: CognitoAuth.AuthChallenge.NO_CHALLENGE,
  group: [GROUP.NO_GROUP]
}

export const auth = {
  state: initialState,

  reducers: {
    /**
     * update current user in store
     *
     * @param {Object} s
     * @param {Object} payload
     * @returns {{Object}}
     */
    setUser: (s, payload) => {
      // Ensure group is always an array
      let groupData = [GROUP.NO_GROUP]
      if (payload !== null && payload.signInUserSession) {
        const cognitoGroups = payload.signInUserSession.idToken.payload["cognito:groups"]
        if (cognitoGroups) {
          groupData = Array.isArray(cognitoGroups) ? cognitoGroups : [cognitoGroups]
        }
      }
      
      return {
        ...s,
        token:
          payload !== null
            ? !!payload.signInUserSession
              ? payload.signInUserSession.idToken
              : ""
            : "",
        user: payload,
        group: groupData,
        state:
          payload !== null
            ? CognitoAuth.AuthStatus.AUTHENTIFICATED
            : CognitoAuth.AuthStatus.UNAUTHENTIFICATED,
        attributes: payload !== null ? payload.attributes || {} : {}
      }
    },
  
    resetUser(s, payload) {
      return {
        ...s,
        token: "",
        user: null
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAction: (s, payload) => {
      return {
        ...s,
        action: payload
      }
    },

    /**
     * Set attributes
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAttributes(s, payload) {
      return {
        ...s,
        attributes: payload
      }
    },
    /**
     * Set current message
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setMessage(s, payload) {
      return {
        ...s,
        message: payload
      }
    },
    /**
     * Set user group
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setGroup: (s, payload) => {
      return {
        ...s,
        group: payload
      }
    },
    /**
     * Update attributes
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    updateAttribute(s, payload) {
      const newAttributes = merge(s.attributes, payload)
      return {
        ...s,
        attributes: newAttributes
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setLoggedIn: (s, payload) => {
      return {
        ...s,
        loggedIn: payload
      }
    },
    /**
     * Update the user's username
     *
     * @param {*} s
     * @param {*} payload
     * @returns {{Object}}
     */
    setUsername: (s, payload) => {
      return {
        ...s,
        username: payload
      }
    },

    /**
     * Update user current challenge
     * NB: This will exist only one time
     * on force password change
     *
     * @param {*} s
     * @param {*} payload
     * @returns {{Object}}
     */
    setChallenge: (s, payload) => {
      return {
        ...s,
        challenge: payload
      }
    },

    /**
     * Set redirect url
     *
     * @param {*} s
     * @param {*} payload
     * @returns {{Object}}
     */
    setRedirect: (s, payload) => {
      return {
        ...s,
        redirect: payload
      }
    },

    /**
     * Update user's authentification state
     *
     * @see {CognitoAuth.AuthStatus}
     * @param {*} s
     * @param {*} payload
     * @returns {Object}
     */
    setState: (s, payload) => {
      return {
        ...s,
        state: payload
      }
    }
  },
  selectors: (slice, createSelector) => ({
    /**
     *
     * @returns
     */
    group() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.auth],
        (auth, authLoading) => {
          return auth.group
        }
      )
    }
  }),
  effects: (dispatch) => ({
    /**
     *
     * @param {*} param0
     */
    async onSignIn({ username, password }) {
      appLogger.info("onSignIn", `[REDUX][${STORES.AUTH}]`)
      this.setAction(globalConst.action.SIGNIN)
      const result = await CognitoAuth.signInUser({
        username,
        password
      })
      if (result && result.challengeName) {
        this.setChallenge(result.challengeName)
        const challengeType = CognitoAuth.AuthChallenge
        switch (result.challengeName) {
          case challengeType.NEW_PASSWORD_REQUIRED:
            const user = {
              email: username,
              password
            }
            localStorage.setItem("tempuser", JSON.stringify(user))
            this.setAction(globalConst.action.FORCE_NEW_PASSWORD)
            this.setUser(result)
            this.setRedirect(globalConst.routes.FORCE_NEW_PASSWORD)
            return globalConst.routes.FORCE_NEW_PASSWORD
            break

          default:
            return "/"
        }
      } else {
     
        // const _msg = message.replace("[nickname]", result.attributes.nickname)
        // dispatch.system.onChangeToast({ msg: _msg, type: "success" })
        localStorage.setItem("keyprefix", result.keyPrefix)
        this.setLoggedIn(true)
        // Ensure group is always an array
        const groupData = resolveAuthGroups(result.signInUserSession.idToken.payload)
        this.setGroup(groupData)
        this.setUser(result)
        this.setState(CognitoAuth.AuthStatus.AUTHENTIFICATED)
        this.setRedirect(globalConst.routes.HOME)
        return globalConst.routes.HOME
      }
    },
    /**
     *
     * @param {*} param0
     */
    async onCompleteNewPassword({ password }) {
      const user = JSON.parse(localStorage.getItem("tempuser"))
      const result = await CognitoAuth.signInUser({
        username: user.email,
        password: user.password
      })
   
      if (result && result.challengeName) {
        if (
          result.challengeName ===
          CognitoAuth.AuthChallenge.NEW_PASSWORD_REQUIRED
        ) {
          const end = await CognitoAuth.completeNewPassword({
            user: result,
            password
          })
          localStorage.removeItem("tempuser")
          this.setLoggedIn(true)
          // Ensure group is always an array
          const groupData = resolveAuthGroups(result.signInUserSession.idToken.payload)
          this.setGroup(groupData)
          this.setAction(globalConst.action.NONE)
          this.setChallenge(CognitoAuth.AuthChallenge.NO_CHALLENGE)
          this.setUser(result)
          this.setState(CognitoAuth.AuthStatus.AUTHENTIFICATED)
          this.setRedirect(globalConst.routes.HOME)
        }
      }
    },
    /**
     *
     */
    async onSignOut() {
      appLogger.info("onSignOut", `[REDUX][${STORES.AUTH}]`)
      await CognitoAuth.signOutUser()
      // this.setState(CognitoAuth.AuthStatus.UNAUTHENTIFICATED)
      this.setUser(null)
      this.setLoggedIn(false)
      this.setGroup([GROUP.NO_GROUP])
      this.setAction(globalConst.action.SIGNOUT)
      this.setRedirect("/auth/login")
      localStorage.removeItem("persist:root")
      localStorage.removeItem("keyprefix")
    },

    handleSignout() {
      this.setUser(null)
      this.setLoggedIn(false)
      this.setGroup([GROUP.NO_GROUP])
      this.setAction(globalConst.action.SIGNOUT)
      this.setRedirect("/auth/login")
      localStorage.removeItem("persist:root")
    },
    /**
     * 
     * @param {*} payload 
     */
    onGroupChanged(payload) {
      const groupData = resolveAuthGroups(payload.signInUserSession.idToken.payload)
      this.setGroup(groupData)
    },
    /**
     *
     * @param {*} payload
     */
    onUserChange(payload) {
      this.setUser(payload)
      this.setLoggedIn(true)
    }
  })
}
